import { CrudState } from "@/store/modules/crud/State";

export class State extends CrudState {
  data: any = {};
}
